import { getAnalyticsSettingChangedEvent } from "../events";
import { getAnalyticsChangeSettingProperties } from "../properties/event";
import type { SetLocalizationSettingAction } from "global/actions";

export async function getChangeSettingLanguageSettingData(msg: SetLocalizationSettingAction) {
    const languageSettingData = getAnalyticsChangeSettingProperties("LanguageSetting", msg.payload.localizationSetting);
    const data = await getAnalyticsSettingChangedEvent(languageSettingData);
    return data;
}
